/**
 * Compute the previous period of equal length, ending right before `from`.
 * Input: ISO strings for from/to.
 * Output: { from, to } ISO strings, or null if inputs invalid.
 */
export const buildPreviousPeriod = (from, to) => {
  if (!from || !to) return null;
  const fromMs = new Date(from).getTime();
  const toMs = new Date(to).getTime();
  if (Number.isNaN(fromMs) || Number.isNaN(toMs) || fromMs >= toMs) return null;

  const len = toMs - fromMs;
  const prevTo = new Date(fromMs - 1);
  const prevFrom = new Date(fromMs - len - 1);
  return {
    from: prevFrom.toISOString(),
    to: prevTo.toISOString(),
  };
};

/** Pretty-print an ISO range for display. */
export const formatRangeLabel = (from, to) => {
  if (!from || !to) return "—";
  const f = new Date(from);
  const t = new Date(to);
  const fmt = (d) =>
    `${String(d.getDate()).padStart(2, "0")}/${String(
      d.getMonth() + 1,
    ).padStart(2, "0")}`;
  return `${fmt(f)} – ${fmt(t)}`;
};
